import { useMutation, useQuery } from '@tanstack/react-query'
import { useParams } from '@tanstack/react-router'
import { useCallback } from 'react'
import { toast } from 'sonner'

import { Label } from '@/components/label/label'
import { Switch } from '@/components/switch/switch'

import { editApplicantNotificationMutation } from '@/lib/queries/business/v1/applicant/mutations'
import { getApplicantDetailQuery } from '@/lib/queries/business/v1/applicant/queries'

export const NotifyApplicantSwitch = () => {
  const { applicantId: pathId } = useParams({
    from: '/_dashboard/applicants/$applicantId/cases/$caseNumber',
  })

  const { data: dataApplicantDetail, refetch: refetchDataApplicantDetail } = useQuery(getApplicantDetailQuery(pathId))

  const mutationEditApplicantNotification = useMutation(editApplicantNotificationMutation)

  const handleEmailNotificationChange = useCallback((isChecked: boolean) => {
    mutationEditApplicantNotification.mutate(
      {
        pathId,
        isEmailNotificationOn: isChecked,
      },
      {
        onSuccess: async () => {
          await refetchDataApplicantDetail()
          toast.success(`Email notification is turned ${isChecked ? 'on' : 'off'}.`)
        },
        onError: () => {
          toast.error('Failed.')
        },
      }
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="px-6">
      <div className="flex items-center justify-between rounded-2xl bg-elevated px-4 py-8">
        <Label className="cursor-pointer" htmlFor="notificationSwitch">
          <div className="mb-1 font-medium">Auto-Notify Applicant</div>
          <div className="text-xs font-medium text-muted-foreground">Client Portal link will be sent via email.</div>
        </Label>
        <div>
          <Switch
            id="notificationSwitch"
            checked={dataApplicantDetail?.notification_mail}
            disabled={!dataApplicantDetail || mutationEditApplicantNotification.isPending || !dataApplicantDetail.email}
            onCheckedChange={handleEmailNotificationChange}
          />
        </div>
      </div>
    </div>
  )
}
